 import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CompleteProfileModal from "../components/CompleteProfileModal"; 
import Navbar from "../components/Navbar";

function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Data from previous page (OTP & Item)
  const { pickupOtp, item } = location.state || {};
  
  // States
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showOtp, setShowOtp] = useState(false);
  const [showModal, setShowModal] = useState(false); 

  // Redirect if accessed directly without data
  useEffect(() => {
    if (!pickupOtp) navigate("/");
  }, [pickupOtp, navigate]);

  // 🔥 Check Profile Status on Load
  useEffect(() => {
    const checkUserProfile = async () => {
        const token = localStorage.getItem("token");
        try {
            const res = await fetch("https://borrowhub-backend.onrender.com/api/user/profile", {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            
            if (data.success && data.user) {
                setUser(data.user);
                localStorage.setItem("user", JSON.stringify(data.user));

                // Check: Is Address & ID present?
                if (data.user.address && data.user.idProof) {
                    setShowOtp(true);
                    setShowModal(false);
                } else {
                    setShowOtp(false);
                    setShowModal(true);
                }
            }
        } catch (error) {
            console.error("Profile check failed", error);
        } finally {
            setLoading(false);
        }
    };

    checkUserProfile();
  }, []);

  // Handle Profile Save
  const handleProfileSaved = (updatedUser) => {
    setUser(updatedUser);
    setShowModal(false);
    setShowOtp(true);
  };

  if (loading) {
      return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="spinner-border text-success" style={{width: "3rem", height: "3rem"}}></div>
        </div>
      );
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      <Navbar />
      
      <div className="container mt-5 flex-grow-1 d-flex justify-content-center">
        <div className="col-md-8 col-lg-6">
          
          {/* ✅ SCENE 1: SHOW OTP (Verified User) */}
          {showOtp && (
            <div className="card border-0 shadow-lg rounded-4 overflow-hidden animate__animated animate__fadeInUp">
              
              {/* Green Header */}
              <div className="bg-success text-white text-center py-4">
                <div className="display-1 mb-2">🎉</div>
                <h2 className="fw-bold m-0">Payment Successful!</h2>
                <p className="mb-0 opacity-75">You have booked <strong>{item?.title}</strong></p>
              </div>

              <div className="card-body p-5 text-center bg-white">
                
                <h5 className="text-uppercase text-muted fw-bold small letter-spacing-1 mb-3">
                    Your Pickup OTP
                </h5>
                
                <div className="bg-light rounded-4 py-3 mb-4 border border-2 border-success border-opacity-25">
                    <h1 className="display-3 fw-bold text-success m-0 letter-spacing-2">
                        {pickupOtp}
                    </h1>
                </div>

                {/* 👉 Instructions (Jo alert me the) */}
                <div className="text-start bg-light p-4 rounded-3 mb-4">
                    <h6 className="fw-bold text-dark mb-3">👉 Next Steps:</h6>
                    <ul className="text-muted small mb-0 ps-3">
                        <li className="mb-2">Visit the Lender/Shop location.</li>
                        <li className="mb-2">Show this <strong>OTP ({pickupOtp})</strong> to the Lender.</li>
                        <li>Lender will enter this OTP in their <strong>"Handover Page"</strong> to confirm pickup.</li>
                    </ul>
                </div>

                <button 
                    className="btn btn-success btn-lg w-100 fw-bold shadow-sm" 
                    onClick={() => navigate("/my-items")}
                >
                  Go to My Items 📦
                </button>

              </div>
            </div>
          )}

          {/* 🛑 SCENE 2: SHOW MODAL (Unverified User) */}
          {showModal && (
            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                <div className="bg-warning text-dark text-center py-4">
                    <h2 className="fw-bold m-0">⚠️ Action Required</h2>
                    <p className="mb-0">Payment successful, but verification pending.</p>
                </div>
                
                <div className="card-body p-4 bg-white">
                    <div className="alert alert-danger border-0 bg-danger bg-opacity-10 text-danger mb-4">
                        <strong>🔒 OTP Locked:</strong> Security reasons se OTP dekhne ke liye please apni <strong>One-Time Verification</strong> complete karein.
                    </div>

                    {/* Modal Content Inline */}
                    <CompleteProfileModal 
                        user={user}
                        onClose={() => {}} // Disabled close
                        onSave={handleProfileSaved}
                    />
                </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;